module.exports = function() {
  return new Worker(__webpack_public_path__ + "2029e3b6e203c4a63b04.worker.js");
};